/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Menu } from 'Components/Menu';
import { shareFacebook } from 'Helpers/share/facebook';
import { shareTwitter } from 'Helpers/share/twitter';
import { shareEmail } from 'Helpers/share/email';
import { copyUrl } from 'Helpers/share/copy-url';
import { useTheme } from '@material-ui/core/styles';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import EmailIcon from '@material-ui/icons/Email';
import HttpIcon from '@material-ui/icons/Http';

export const SocialShareButton = ({ socialShareMessage, nftPageUrl }) => {
  const theme = useTheme();

  return (
    <Menu
      menuItems={[
        {
          icon: <FacebookIcon />,
          text: 'Share on Facebook',
          onClick: () => {
            console.log('Launch Facebook Share Dialog');
            shareFacebook({
              socialShareType: 'share',
              socialShareUrl: nftPageUrl,
            });
          },
        },
        {
          icon: <TwitterIcon />,
          text: 'Share on Twitter',
          onClick: () => {
            console.log('Launch Twitter Share Dialog');
            shareTwitter({
              socialShareText: socialShareMessage,
            });
          },
        },
        {
          icon: <EmailIcon />,
          text: 'Share on Email',
          onClick: () => {
            console.log('Launch Email Share Dialog');
            shareEmail({
              socialShareSubject: socialShareMessage,
              socialShareBody: window.location.href,
            });
          },
        },
        {
          icon: <HttpIcon />,
          text: 'Copy Link',
          onClick: ({ closeMenu }) => {
            console.log('Copy URL to clipboard');
            copyUrl(nftPageUrl);
            closeMenu();
          },
        },
      ]}
    >
      <img
        src="/img/share.png"
        alt="more button"
        css={css`
          width: 20px;
          ${theme.breakpoints.up('sm')} {
            width: 27px;
          }
        `}
      />
    </Menu>
  );
};
